import {GET_SELECTEDDAYFROMWEEK} from '../Actions/types'

const initialState= { 
    selectedDayFromWeek: "",

}

export default function (state = initialState, action) {

        switch(action.type) {
            case GET_SELECTEDDAYFROMWEEK: 
                return{
                    ...state,
                    selectedDayFromWeek: action.payload
                };
                default: 
            return state;

        }
    }



// WEBPACK FOOTER //
// ./src/Reducers/GetSelectedDayFromWeekReducer.js